import {Ng2StateDeclaration} from '@uirouter/angular';
import {getArticleSpecificationResolveFn} from '../../envisia/article/article.states';
import {ArticleSpecificationService} from '../../envisia/article/services/article-specification.service';
import {MultilayerPlanComponent} from './multilayer-plan.component';

const MULTILAYER_PLAN_STATE: Ng2StateDeclaration = {
  name: 'a.multilayerplan',
  url: '/multilayerplan?shared_id&name&oa_nr&active&deleted&with_article&page&sort&order',
  data: {requiresAuth: true},
  views: {'main@a': {component: MultilayerPlanComponent}},
  params: {
    shared_id: {dynamic: true},
    name: {dynamic: true},
    oa_nr: {dynamic: true},
    active: {dynamic: true},
    deleted: {dynamic: true},
    with_article: {dynamic: true},
    page: {dynamic: true},
    sort: {dynamic: true},
    order: {dynamic: true},
  },
  resolve: [
    {token: 'specification', resolveFn: getArticleSpecificationResolveFn, deps: [ArticleSpecificationService]},
  ]
};

export const MULTILAYER_PLAN_STATES: Ng2StateDeclaration[] = [
  MULTILAYER_PLAN_STATE,
];
